import { createI18n } from 'vue-i18n';

// import en from 'locales/en.json';
// const en = await (await fetch('/locales/en.json')).json();
const messages = {
    // en
};

export default createI18n({
    locale: import.meta.env.VITE_DEFAULT_LOCALE,
    fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
    legacy: false, // <--- 3
    globalInjection: true,
    messages,
});
